import { connect } from 'react-redux';
import React from 'react';
import MMdriver from '../../components/MMdriver';
import { fetchMMDriversByTime, editDriverInfomation }  from '../../actions/mmdriver-actions'

function mapStateToProps(state) {
  return {
      drivers: state.MMDrivers.drivers
  }
}

export default connect(mapStateToProps, { fetchMMDriversByTime, editDriverInfomation })(MMdriver);



// WEBPACK FOOTER //
// ./master/jsx/containers/MMdriver/index.jsx